<template>
  <div>
    <b-modal
      id="modalEntretien"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      size="xl"
      :title="titleModal"
    >
      <template #default>
        <form @submit.prevent="submit" @keydown="form.onKeydown($event)">
          <div class="row d-flex justify-content-center mt-n1">
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label for="date_entretien"
                  >Date et heure de d'entretien
                  <span class="text-danger">*</span></label
                >
                <date-picker
                  v-model="form.date_entretien"
                  name="date_entretien"
                  placeholder="Date et heure de l'entretien"
                  type="datetime"
                  lang="fr"
                  format="DD/MM/YYYY HH:mm"
                  value-type="DD/MM/YYYY HH:mm"
                ></date-picker>
                <input
                  class="form-control"
                  :class="{
                    'is-invalid': form.errors.has('date_entretien'),
                  }"
                  type="hidden"
                />
                <has-error :form="form" field="date_entretien"></has-error>
              </div>
            </div>
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label for="responsable"
                  >Responsable <span class="text-danger">*</span></label
                >
                <v-custom-select
                  label="nom"
                  :options="filterResponsables"
                  :reduce="(filterResponsable) => filterResponsable.uuid"
                  v-model="form.responsable"
                  placeholder="Responsable"
                >
                  <template v-slot:option="{ nom }">
                    <h5 style="margin: 0">{{ nom }}</h5>
                  </template>
                  <template #no-options> Aucune données </template>
                  <template #search="{ attributes, events }">
                    <input
                      id="responsable"
                      class="custom-select-height vs__search"
                      v-bind="attributes"
                      v-on="events"
                    />
                  </template>
                </v-custom-select>
                <div>
                  <input
                    type="hidden"
                    class="form-control"
                    :class="{
                      'is-invalid': form.errors.has('responsable'),
                    }"
                  />
                  <has-error :form="form" field="responsable"></has-error>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label for="entretien_type"
                  >Type d'entretien <span class="text-danger">*</span></label
                >
                <v-custom-select
                  label="nom"
                  :options="entretienTypes"
                  :reduce="(entretienType) => entretienType.uuid"
                  v-model="form.entretien_type"
                  placeholder="Type d'entretien"
                >
                  <template v-slot:option="{ nom }">
                    <h5 style="margin: 0">{{ nom }}</h5>
                  </template>
                  <template #no-options> Aucune données </template>
                  <template #search="{ attributes, events }">
                    <input
                      id="entretien_type"
                      class="custom-select-height vs__search"
                      v-bind="attributes"
                      v-on="events"
                    />
                  </template>
                </v-custom-select>
                <div>
                  <input
                    type="hidden"
                    class="form-control"
                    :class="{
                      'is-invalid': form.errors.has('entretien_type'),
                    }"
                  />
                  <has-error :form="form" field="entretien_type"></has-error>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label for="statut"
                  >Statut de l'entretien
                  <span class="text-danger">*</span></label
                >
                <v-custom-select
                  label="text"
                  :options="entretienStatuts"
                  :reduce="(entretienStatut) => entretienStatut.value"
                  v-model="form.statut"
                  placeholder="Statut de l'entretien"
                >
                  <template v-slot:option="{ text, value }">
                    <h5 style="margin: 0">
                      <i
                        class="mdi mdi-checkbox-blank-circle mr-1"
                        :class="getClassOfEntretien(value)"
                      ></i>
                      {{ text }}
                    </h5>
                  </template>
                  <template #no-options> Aucune données </template>
                  <template #search="{ attributes, events }">
                    <input
                      id="statut"
                      class="custom-select-height vs__search"
                      v-bind="attributes"
                      v-on="events"
                    />
                  </template>
                </v-custom-select>
                <div>
                  <input
                    type="hidden"
                    class="form-control"
                    :class="{
                      'is-invalid': form.errors.has('statut'),
                    }"
                  />
                  <has-error :form="form" field="statut"></has-error>
                </div>
              </div>
            </div>
          </div>
        </form>
      </template>
      <template #modal-footer>
        <button
          type="button"
          class="btn btn-danger mr-2"
          @click="$bvModal.hide('modalEntretien')"
        >
          Fermer
        </button>

        <button
          type="submit"
          class="btn btn-custom-primary w-40"
          @click="submit"
          style="min-width: 100px"
        >
          Enregistrer
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import URL from '@/http/rh/entretien/entretien-individuel';
import Form from 'vform';
import DatePicker from 'vue2-datepicker';
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      form: new Form({
        date_entretien: '',
        responsable: '',
        entretien_type: '',
        statut: '',
      }),
      titleModal: "Edition de l'entretien",
    };
  },
  components: {
    DatePicker,
  },
  computed: {
    ...mapGetters('entretien', [
      'entretienStatuts',
      'employes',
      'entretienTypes',
    ]),
    filterResponsables() {
      return (
        window._.filter(
          this.employes,
          (emp) => emp.uuid != this.form.employe
        ) || []
      );
    },
  },
  methods: {
    ...mapActions('entretien', ['setEmployes', 'setEntretienTypes']),

    async edit(id) {
      this.form.reset();
      this.form.clear();

      await window.axios
        .all([
          window.axios.get(URL.GET_REQUIREMENTS),
          window.axios.get(URL.ENTRETIEN_INDIVIDUEL + '/' + id, {
            params: {
              edit: true,
            },
          }),
        ])
        .then(
          window.axios.spread((resp1, resp2) => {
            this.setEmployes(resp1.data.employes);
            this.setEntretienTypes(resp1.data.entretien_types);
            Object.assign(this.form, resp2.data.entretien_individuel);
            if (!this.form.date_entretien)
              this.form.date_entretien = this.$options.filters.formatDate(
                new Date(),
                'DD/MM/YYYY HH:mm'
              );
          })
        )
        .catch(() => {});

      await this.$bvModal.show('modalEntretien');
    },
    submit() {
      this.$bvModal.hide('modalEntretien');

      this.form
        .put(URL.ENTRETIEN_INDIVIDUEL + '/' + this.form.id)
        .then((resp) => {
          this.showSimpleAlerte('top-end', 'success', resp.data.message);

          this.form.reset();
          this.form.clear();
          this.$emit('onRefresh');
        })
        .catch(() => {
          this.$bvModal.show('modalEntretien');
        });
    },
  },
};
</script>

<style scoped lang="scss"></style>
